import { View, styled } from 'tamagui'
import { useAppStore } from '@/store'
import { UserSettingsNav } from './UserSettingsNav'
import { AccountSettings } from './AccountSettings'
import { PrivacySettings } from './PrivacySettings'
import { AppearanceSettings } from './AppearanceSettings'
import { VoiceVideoSettings } from './VoiceVideoSettings'
import { NotificationSettings } from './NotificationSettings'
import { KeybindSettings } from './KeybindSettings'
import { SubscriptionSettings } from './SubscriptionSettings'

const Container = styled(View, {
  flex: 1,
  flexDirection: 'row',
  backgroundColor: '$surface',
})

const Content = styled(View, {
  flex: 1,
  overflow: 'hidden',
})

function SettingsContent() {
  const { userSettingsTab } = useAppStore()
  switch (userSettingsTab) {
    case 'account': return <AccountSettings />
    case 'privacy': return <PrivacySettings />
    case 'appearance': return <AppearanceSettings />
    case 'voice-video': return <VoiceVideoSettings />
    case 'notifications': return <NotificationSettings />
    case 'keybinds': return <KeybindSettings />
    case 'subscription': return <SubscriptionSettings />
    default: return <AccountSettings />
  }
}

export function UserSettings() {
  return (
    <Container>
      <UserSettingsNav />
      <Content>
        <SettingsContent />
      </Content>
    </Container>
  )
}
